export const ErrorAlert = ({
  title = 'Ocorreu um erro',
  description = 'Tente novamente em instantes.'
}) => (
  <div className="alert alert-danger mb-0">
    <div className="font-semibold">{title}</div>
    <div className="text-sm">{description}</div>
  </div>
)
